import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { MDBRow } from 'mdb-react-ui-kit';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import PrivacyPolicy from './contenuto';

const Transition = React.forwardRef(function Transition(props, ref) {
 return <Slide direction="up" ref={ref} {...props} />;
});

export default function IntormativaPrivacy({ handleChange, checked }) {
 const [open, setOpen] = React.useState(false);

 const handleClickOpen = () => {
  setOpen(true);
 };

 const handleClose = () => {
  setOpen(false);
 };

 return (
  <>
   <MDBRow>
        <FormControlLabel 
        control={<Checkbox defaultChecked checked={checked} onChange={handleChange} />}
        label= {<>Ho preso visione e letto l’informativa <a style={{color:'#1976d2'}} onClick={handleClickOpen}>Privacy Policy</a></>}
        />
   </MDBRow>
   <Dialog
    fullScreen
    open={open}
    onClose={handleClose}
    TransitionComponent={Transition}
   >
    <AppBar sx={{ position: 'fixed' }}>
     <Toolbar>
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
       Informativa sulla Privacy - Notaio Treviso
      </Typography>
      <Button onClick={handleClose} aria-label="close" color="inherit">CHIUDI</Button>

     </Toolbar>
    </AppBar>
    <List>
     <br></br>
     <PrivacyPolicy />
    </List>
   </Dialog>
  </>
 );
}
